module.exports = __webpack_public_path__ + "img/more-delete.43d361bf.svg";